/**
 * @fileoverview POST handler for the "/generative_ai/dalle_assistant" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiDalleAssistantCacheKeys } from "./constants";
import type { PostGenerativeAiDalleAssistantProps, GenerativeAiDalleAssistantResult } from "./types";

export const postGenerativeAiDalleAssistant = reactQueryMutationAdapter(
  generativeAiDalleAssistantCacheKeys,
  (props: PostGenerativeAiDalleAssistantProps): Promise<GenerativeAiDalleAssistantResult> => {
    return fetch("/generative_ai/dalle_assistant", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
